/** @format */

import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	Output,
	QueryList,
	ViewChildren,
	OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { ApiServiceService } from "../../../../../Services/api-service.service";
import { FormService } from "../form.service";
import { FormGroup } from "@angular/forms";

@Component({
	selector: "app-verification-code",
	templateUrl: "./verification-code.component.html",
	styleUrls: ["./verification-code.component.css"],
})
export class VerificationCodeComponent implements OnInit {
	emailPhone = "";
	vStage1 = true;
	vStage2 = false;
	vStage3 = false;
	channel = "";
	isCodeReady = false;
	isLoading = false;
	codeSentMSG = "";
	codeConfirmMSG = "";
	form: FormGroup;
	@ViewChildren("inputField") inputFields: QueryList<ElementRef>;

	constructor(
		private router: Router,
		private apiServer: ApiServiceService,
		private formService: FormService,
	) {
		this.form = formService.getForm();
		this.startCountdown();
	}

	ngOnInit() {
		this.TChannel("email");
	}

	digit1: string = "";
	digit2: string = "";
	digit3: string = "";
	digit4: string = "";
	digit5: string = "";
	digit6: string = "";

	combinedNumber: number | null = null;

	screenHeight = window.screen.height - 271; // 1058
	minHeight = "min-height: " + this.screenHeight + "px !important";

	screenHeight2 = window.screen.height - 630; // 428
	minHeight2 = "min-height: " + this.screenHeight2 + "px !important";

	countdownSeconds: number = 30;
	countdownTimer: any;
	isCountDown: boolean = false;

	tvStage(v) {
		switch (v) {
			case 1:
				this.vStage1 = true;
				this.vStage2 = false;
				this.vStage3 = false;
				break;
			case 2:
				this.vStage1 = false;
				this.vStage2 = true;
				this.vStage3 = false;
				break;
			case 3:
				this.vStage1 = false;
				this.vStage2 = false;
				this.vStage3 = true;
				break;
		}
	}
	startCountdown() {
		this.countdownSeconds = 30;
		this.countdownTimer = setInterval(() => {
			if (this.countdownSeconds > 0) {
				this.isCountDown = true;
				this.countdownSeconds--;
			} else {
				this.isCountDown = false;
				clearInterval(this.countdownTimer);
			}
		}, 1000);
	}
	ngOnDestroy() {
		clearInterval(this.countdownTimer);
	}
	async TChannel(t) {
		this.isLoading = true;
		this.startCountdown();
		this.emailPhone = t;
		try {
			this.apiServer
				.loginPost_("/auth/enumeration/send/code", {
					email: this.formService.businessDetailsGroup.get("email")
						.value,
					phoneNumber:
						this.formService.businessDetailsGroup.get("phone")
							.value,
					messageType: this.emailPhone,
				})
				.subscribe((res) => {
					this.isLoading = false;
					this.codeSentMSG = res.message;
					// this.message = res.message;
					console.log("from me: ", res);
				});
		} catch (e) {
			console.log("from me: ", e);
		}
		this.isCodeReady = true;
	}

	prevStage() {
		this.vStage1 = true;
		this.vStage2 = false;
		this.vStage3 = false;
	}

	submit() {
		const digits =
			this.digit1 +
			this.digit2 +
			this.digit3 +
			this.digit4 +
			this.digit5 +
			this.digit6;
		this.combinedNumber = parseInt(digits, 10);
		this.apiServer
			.loginPost_("/auth/enumeration/confirm/code", {
				email: this.formService.businessDetailsGroup.get("email").value,
				phoneNumber:
					this.formService.businessDetailsGroup.get("phone").value,
				code: digits,
			})
			.subscribe((res) => {
				if (res.message.includes("Success")) {
					this.codeConfirmMSG = res.message;
					setTimeout(() => {
						this.tvStage(3);
						// this.changeState.emit({ state: true })
					}, 1000);
				} else {
					this.codeConfirmMSG = res.message;
				}
			});
		this.moveToNext();
	}

	moveToNext() {
		this.nextStep();
	}

	nextInput(event: KeyboardEvent, index: number) {
		const target = event.target as HTMLInputElement;
		const valueLength = target.value.length;
		const maxLength = target.maxLength;

		if (event.key === "Backspace" || event.key === "Delete") {
			if (valueLength === 0 && index > 0) {
				this.inputFields.toArray()[index - 1].nativeElement.focus();
			}
		} else {
			if (
				valueLength >= maxLength &&
				index < this.inputFields.length - 1
			) {
				this.inputFields.toArray()[index + 1].nativeElement.focus();
			}
		}
	}

	nextStep() {
		this.formService.sendMessage(2);
	}

	backStep() {
		this.formService.sendMessage(0);
	}
}
